var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15C11.866 15 15 11.866 15 8C15 4.134 11.866 1 8 1C4.134 1 1 4.134 1 8C1 9.3775 1.39788 10.6621 2.08499 11.745L1 15L4.25497 13.915C5.33794 14.6021 6.6225 15 8 15Z",
    fill: "#25D366"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.899 5.82885C4.54072 8.83499 7.11161 11.3715 9.87734 11.1679C10.613 11.1137 11.1681 10.28 10.9837 9.71632C10.9181 9.54199 10.2283 9.24332 9.63814 9.06958C9.61604 9.06307 9.59242 9.0723 9.58037 9.09196L9.15945 9.77827C9.14776 9.79732 9.12473 9.80655 9.10309 9.80101C7.48038 9.38645 6.65953 8.36843 6.2 6.74707C6.19384 6.72536 6.20266 6.70195 6.22169 6.68982L6.9083 6.25254C6.92033 6.24487 6.92866 6.23279 6.93089 6.21869C7.01161 5.70846 6.74156 4.79923 6.65061 4.73741C6.09746 4.36144 5.01103 4.88905 4.899 5.82885Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/Whatsapp.b1439f8e4967a92886114da38632d5ff.svg";
export { ForwardRef as ReactComponent };